import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from '@app-services/local-storage.service';
import { STORAGE_NAMES } from '@app-shared/constants/constants';
import { Router } from '@angular/router';

const { PRE_RELEASE } = STORAGE_NAMES;

@Component({
  selector: 'app-test-page',
  imports: [MatButtonModule, TranslateModule],
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss'],
})
export class TestPageComponent implements OnInit {
  preRelease = false;

  constructor(
    private localStorageService: LocalStorageService,
    protected router: Router
  ) {}

  ngOnInit(): void {
    this.preRelease = this.localStorageService.getData(PRE_RELEASE);
    if (!this.preRelease) {
      this.router.navigate([`/`]);
    }
  }

  onClickButton(): void {
    throw Error('Check error');
  }
}
